import { render, staticRenderFns } from "./DatosBancariosSalud.vue?vue&type=template&id=328a4cc9&scoped=true&"
import script from "./DatosBancariosSalud.vue?vue&type=script&lang=js&"
export * from "./DatosBancariosSalud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328a4cc9",
  null
  
)

export default component.exports